module.exports = __webpack_public_path__ + "img/card 3.b9387b0b.svg";